import { IEditorV3, stringToV3 } from "@azu-business/editor-v3";
import { AitHeaderGroupData, AitRowGroupData } from "aic";
import { ColumnInformationDto } from "components/annotations/interface";
import { eTlfItemType } from "../enums";
import { bodyPreProcess } from "./bodyPreProcess";
import { generateColumnIds } from "./generateColumnIds";
import { handleCellText } from "./handleCellText";
import { headerPreProcess } from "./headerPreProcess";
import { TlfItemReadDto, TlfListingReadDto, TlfTableReadDto } from "./TlfItemReadDto";

/**
 * Ensure a TLF item has required body defaults and column metadata.
 * For tables and listings this will generate column ids, ensure column
 * information exists and normalise header and body structures.
 *
 * @param tlf - TLF item from the backend
 * @returns The processed TLF item ready for client use
 */
export const tlfPreProcess = (tlf: TlfItemReadDto): TlfItemReadDto => {
  if (tlf.type === eTlfItemType.table || tlf.type === eTlfItemType.listing) {
    // Generate columnIds once and use for both header and body
    const columnIds = generateColumnIds(tlf.body);

    // Generate columnInformation if empty
    const columnInformation: ColumnInformationDto[] =
      tlf.body.columnInformation &&
      tlf.body.columnInformation.length > 0 &&
      columnIds.length === tlf.body.columnInformation.length
        ? tlf.body.columnInformation
        : columnIds.map((columnId, index): ColumnInformationDto => ({
            columnId,
            originalColumnIndex: index,
          }));
    const headerData: AitHeaderGroupData<IEditorV3> | false = headerPreProcess(
      60,
      stringToV3(""),
      columnIds,
      handleCellText(tlf.body.headerData),
    );
    const bodyData: AitRowGroupData<IEditorV3>[] = bodyPreProcess(
      60,
      stringToV3(""),
      columnIds,
      handleCellText(tlf.body.bodyData) as AitRowGroupData<IEditorV3>[],
    );

    return {
      ...tlf,
      body: {
        ...tlf.body,
        columnInformation,
        headerData,
        bodyData,
      },
    } as TlfTableReadDto | TlfListingReadDto;
  } else return tlf;
};
